module.exports = __webpack_public_path__ + "static/media/ic_下载.c22219a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_下载.svg
// module id = 370
// module chunks = 0